import { createApiMutation, createApiQuery } from '@/features/api'

import type { PosDeviceRole } from './schema'
import type { IPos } from './type'

export const posDeviceList = createApiQuery<{
	params: { oId: string }
	result: { devices: Array<IPos> }
}>('/pos/device/list')

export const posDeviceDetail = createApiQuery<{
	params: { id: string; oId: string }
	result: { device: IPos }
}>('/pos/device/detail')

export const posDeviceCreate = createApiMutation<{
	body: { oId: string; name: string; role: PosDeviceRole }
	result: { id: string }
}>('/pos/device/create', { method: 'post' })

export const posDeviceRefreshToken = createApiMutation<{
	body: { id: string; oId: string }
	result: { token: string }
}>('/pos/device/refresh-token', { method: 'post' })
